export default __webpack_public_path__ + "static/media/trylleby-property-07.c4e7465d.jpg";